export function getKeyOfPropertyUnit(key: string, securityCount: number, unitCount: number) {
  if (securityCount === 0) {
    return `${key}_${unitCount}`;
  }

  return `${key}_${securityCount}_${unitCount}`;
}
